module.exports = __webpack_public_path__ + "static/img/our-people-low.85d5a44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/our-people-low.jpg
// module id = aJEf
// module chunks = 0